const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are just two steps away from finishing the digital vehicle inspection',
	'landing.stepDescription.fourAdditionalPictures': 'Take the required photos',
	'landing.stepDescription.fourDiagonalPerspectives': 'Take the required pictures',
	'landing.stepDescription.feedback': 'Let us know how it went',
	'landing.termsAndConditionsLinkDescription':
		'By pressing "Start" you are accepting our <tclink>Terms and conditions.</tclink>',
	termsAndConditionsLink: 'By proceeding, you are accepting our terms and conditions.',
	'button.start': 'Start',
	'landing.aboutPolicyCheck': 'Back',
	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.text':
		'<ul><li>you have the keys and the registration certificate at hand</li><li>you are in a place with good light and mobile network</li><li>the vehicle is accessible from all angles and all side windows are closed</li></ul>',
	'landing.additional-informations-section.text.motorbike':
		"<ul><li class='landing-additional-information-line'>You are in a place with good light and mobile network</li><li class='landing-additional-information-line'>The vehicle is accessible from all angles.</li></ul>",
	'chooseLang.headline': 'Choose your preferred language',
	'button.close': 'Close',
	'blockedByDevice.headline': 'PolicyCheck does not support desktop browsers',
	'blockedByDevice.description':
		'PolicyCheck is using a desktop browser.<br>The PolicyCheck platform performs documenting cases using mobile devices. To continue, please run the PolicyCheck link on a mobile device',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.second':
		'All these circumstances allow us to provide you with a realistic cost estimate in such a short time.',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of 8 simple steps.',

	'vehicleImages.overviewPhotos': 'Vehicle overview',
	'vehicleImages.overviewPhotos.subtitle': 'Photograph vehicle',
	'vehicleImages.description':
		'Take photos of the vehicle from all angles. The license plate should be clearly visible in all of them.',
	'vehicleImages.description.motorbike':
		'Photograph vehicle diagonally front left and right, rear left and right. The license plate must be visible in all rear pictures.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Front right diagonal',
	'button.next': 'Next',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Photo example',
	'imageRecognitionMismatchModal.headline': 'Let’s check if the photos you added are correct',
	'button.continue': 'CONTINUE',
	'button.backchangeImage': 'RETAKE THE PHOTO',
	'completeVehicleImagesModal.headline': 'Missing photos',
	'completeVehicleImagesModal.description': 'Please add the following photographs:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Front left diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Rear left diagonal',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Front right diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Rear right diagonal',
	'vehicleImages.leftFrontOverview': 'Front left diagonal',
	'vehicleImages.leftRearOverview': 'Rear left diagonal',
	'vehicleImages.rightRearOverview': 'Rear right diagonal',
	'vehicleImages.rightFrontOverview': 'Front right diagonal',
	'button.changeImage': 'RETAKE THE PHOTO',
	'button.deleteImage': 'Delete the photo',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Front left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Rear left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Rear right diagonal example photo',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Front right diagonal example photo',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'fourAdditionalPictures.title': 'Additional information',
	'fourAdditionalPictures.overallDashboard.title': 'Dashboard',
	'fourAdditionalPictures.overallDashboard.description':
		'Take a photo showing a complete dashboard of the vehicle.',
	'fourAdditionalPictures.mileage.title': 'Mileage',
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle odometer with the current mileage visible. If you have a digital display, please turn it on.',
	'dashboardMileage.paragraph.first': 'Enter the current mileage.',
	'dashboardMileage.placeholder': 'Current mileage',
	'dashboardMileage.input.error': 'Please enter the current mileage of the vehicle',
	'fourAdditionalPictures.windshield.title': 'Windshield',
	'fourAdditionalPictures.windshield.description':
		'Take a detailed photo of the vehicle’s windshield.',
	'fourAdditionalPictures.vin.title': 'VIN number',
	'fourAdditionalPictures.vin.description':
		'Take a photo of the vehicle’s VIN number. It can be found on the driver’s door seal or in the bottom left corner of the windshield.',
	'mileageModal.headline': "Let's check if the mileage value you added is correct",
	'mileageModal.paragraph':
		'The photo mileage value differs from that entered in the field. Change the value or confirm to proceed if you find that the mileage you entered is correct.',
	'mileageModal.insertedMileagePlaceholder': 'Mileage value that you entered',
	'mileageModal.pictureMileage': 'Mileage value taken from the picture',
	'button.reverse': 'Keep Photo Milege',
	'button.confirm': 'Confirm My Mileage',
	'overallDashboardImage.title': 'Dashboard',
	'dashboardMileage.dashboard.title': 'Mileage',
	'windshieldImage.title': 'Windshield',
	'vinPicture.title': 'Photo of the VIN number',
	'completeFourAdditionalPicturesModal.headline': 'Missing photos',
	'completeFourAdditionalPicturesModal.description': 'Please include the following photographs:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Dashboard',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Mileage',
	'completeDashboardMileageModal.hasValidMileage':
		'Please enter the current mileage of the vehicle',
	'completeFourAdditionalPicturesModal.hasVINImage': 'VIN number',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Windshield',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Dashboard example photo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Mileage example photo',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Windshield example photo',
	'fourAdditionalPictures.vin.exampleModalTitle': 'VIN number example photo',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',

	'feedback.headline.policyCheck': 'All pictures were received successfully!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck': 'How would you rate your experience with the app?',
	'feedback.yourOpinion': 'Any comments? Let us know!',
	'feedback.comment.placeholder': 'Add your comment',
	'feedback.button.send': 'Submit',
	'waitForAudit.thankYou': 'Inspection process is already sucessfully finished. Thank you!',
	'waitForAudit.description.damageFound': ' ',
	'thanks.headline.first': 'Thank you for feedback!',
	'thanks.paragraph.first': ' ',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
